import $http from '@/plugins/http.js'

export function EnglishLogin(params) {
    return $http.post('/lo/login', params)
}

export function logout() {
    return $http.get('/logout')
}
